export default __webpack_public_path__ + "static/media/views_top.e5fea689.svg";